// extracted by mini-css-extract-plugin
export var divider = "_vs-0";